import React, { useContext, useState } from 'react';
import './styles.css';
import P from 'prop-types';
import useWindowDimensions, {
  GetDadosProduto,
  GetMontagem,
  GetSacola,
  isObjectEmpty,
  RemoveItem,
  UpdateItensCount,
} from '../../utils/utils';
import EmptyBag from '../../img/empty_bag.png';
import { Capitalize } from '../../utils/utils';
import { FormataValor } from '../../utils/utils';
import { SacolaRodape } from '../SacolaRodape';
import { ValoresTotais } from '../ValoresTotais';
import { Modal } from '../Modal';
import { toast } from 'react-toastify';
import { GlobalContext } from '../../contexts/HomeContext';
import { Image } from '../Image';

export const Sacola = ({ param }) => {
  const { dadosApp, setSacola } = useContext(GlobalContext);
  const [modalEdicao, setModalEdicao] = useState(false);
  const [modalDetalhes, setModalDetalhes] = useState(false);
  const [itemSelecionado, setItemSelecionado] = useState({});
  const { width } = useWindowDimensions();
  const obj = GetSacola(dadosApp);

  // const showHideModalDetalhes = () => {
  //   setModalDetalhes(modalDetalhes == 'none' ? 'block' : 'none');
  // };

  const handleItemEdicao = (item) => {
    // obtem os dados do produto
    let ProdutoSelecionado = { ...GetDadosProduto(dadosApp, item.Produto.codigo_produto) };
    if (isObjectEmpty(ProdutoSelecionado)) {
      toast.error('Não foi possível obter os dados do produto');
      handleExcluir(item.Produto, false);
      return;
    }
    ProdutoSelecionado.id = item.Produto.id;
    ProdutoSelecionado.quantidade = item.Produto.quantidade;
    ProdutoSelecionado.observacao = item.Produto.observacao_pedido;
    ProdutoSelecionado.tipo_produto = item.Produto.tipo_produto;
    ProdutoSelecionado.tipoPizza = item.Produto.tipoPizza;
    ProdutoSelecionado.tamanho = item.Produto.tamanho; // adicionado por conta dos tamanhos

    setItemSelecionado(ProdutoSelecionado);
    setModalEdicao(true);
  };

  const handleEditar = () => {
    setModalDetalhes(true);
    setModalEdicao(false);
  };

  const handleExcluir = (item, hide = true) => {
    RemoveItem(item.idloja, item.id);
    UpdateItensCount(dadosApp.IdLoja, setSacola, dadosApp.Empresa.Config.pizza_cobranca);
    if (hide) setModalEdicao(false);
  };

  return (
    <>
      <div className={`${param.origin == 'desktop' ? 'col-lg-4' : ''}`} id="sidebar_fixed">
        <div className="theiaStickySidebar">
          {param.origin == 'desktop' && (
            <div className="head">
              <h3>{dadosApp.TipoApp === 'DELIVERY' ? 'Sacola' : 'Pedido'}</h3>
            </div>
          )}
          <div
            className="mobile_fixed box_order"
            style={{ display: 'block', marginBottom: width > 991 ? '' : '60px', borderRadius: '0 0 5px 5px' }}
          >
            {/* {param.origin == 'desktop' && (
              <div className="head">
                <h3>{dadosApp.TipoApp === 'DELIVERY' ? 'Sacola' : 'Pedido'}</h3>
              </div>
            )} */}

            <div className="main" style={{ paddingBottom: '0' }}>
              {obj.itens.length == 0 && (
                <ul className="clearfix" style={{ padding: '25px 25px 50px 25px' }}>
                  <>
                    {/* <h1>:(</h1> */}
                    <Image srcLocal={EmptyBag} />
                    <h4>Sua sacola esta vazia</h4>
                  </>
                </ul>
              )}
              {obj.itens.length > 0 &&
                obj.itens.map((item, index) => (
                  <ul
                    key={'item' + index}
                    className="clearfix"
                    style={{ borderBottom: '1px solid #ededed', margin: '0 5px 10px 0' }}
                  >
                    <li>
                      <span
                        onClick={() => handleItemEdicao(item)}
                        style={{
                          margin: '-3px -20px 0 5px',
                          color: '#e54750',
                          cursor: 'pointer',
                        }}
                      >
                        <i className="material-icons">more_vert</i>
                      </span>
                      <span style={{ fontSize: '16px', margin: '-3px 0 0 10px', fontWeight: 500, color: '#3f3e3e' }}>
                        {FormataValor(item.VTotal)}
                      </span>
                      {/* {item.Produto.tipo_produto == 'PIZZA' && item.Produto.tipoPizza == 'FRACAO' && ( */}
                      {item.Produto.tipo_produto == 'PIZZA' && (
                        <p style={{ fontSize: '14px', margin: '0' }}>
                          {item.Produto.quantidade_texto + ' '} &#8287;
                          {Capitalize(item.Produto.descricao_produto)}
                        </p>
                      )}
                      {item.Produto.tipo_produto != 'PIZZA' && (
                        <>
                          <p style={{ fontSize: '14px', margin: '0', display: 'flex' }}>
                            {/* <p style={{ fontSize: '14px', margin: '0' }}>
                              {item.Produto.quantidade_texto + 'x '} &#8287;
                              {Capitalize(item.Produto.descricao_produto)}
                            </p> */}
                            {item.Produto.quantidade_texto + 'x '} &#8287;
                            {Capitalize(item.Produto.descricao_produto)}
                            {item.Produto.tamanho && (
                              <span
                                style={{
                                  fontSize: '14px',
                                  margin: '0 0 0 5px',
                                  color: '#717171',
                                  fontWeight: 400,
                                }}
                              >
                                {Capitalize(item.Produto.tamanho)}
                              </span>
                            )}
                          </p>
                        </>
                      )}
                      {item.ItensMontagemText.length > 0 && (
                        <p style={{ fontSize: '14px', margin: '0 0', color: '#717171' }}>{item.ItensMontagemText}</p>
                      )}
                      {item.Produto.observacao_pedido.length > 0 && (
                        <p style={{ fontSize: '14px', margin: '0 0', color: '#717171', fontWeight: 300 }}>
                          {'Obs. ' + item.Produto.observacao_pedido}
                        </p>
                      )}
                    </li>
                  </ul>
                ))}
            </div>
            <div className="main" style={{ paddingTop: '0', paddingBottom: '0', overflow: 'hidden' }}>
              {obj.itens.length > 0 && (
                <ValoresTotais
                  origin={param.origin}
                  taxa_text={
                    (dadosApp.Empresa.Config.taxa_tipo == 'Km' && 'a calcular') ||
                    (dadosApp.Empresa.Config.taxa_tipo == 'Regiao' && 'a calcular') ||
                    (dadosApp.Empresa.Config.taxa_tipo == 'Região' && 'a calcular')
                  }
                  subtotal={obj.subtotal}
                  taxa={obj.taxa}
                  total={obj.total}
                  isDelivery={dadosApp.TipoApp === 'DELIVERY'}
                />
              )}
            </div>

            {/* {obj.itens.length > 0 && width > 991 && <SacolaRodape param={param} />} */}
          </div>
          {param.origin == 'desktop' && (
            // <div className="head sacola-footer btn_1 btnGradientInverted">
            //   <h3>Finalizar</h3>
            // </div>
            <div style={{ marginTop: -3 }}>{obj.itens.length > 0 && width > 991 && <SacolaRodape param={param} />}</div>
          )}
        </div>
      </div>
      {modalEdicao && (
        <Modal
          title={itemSelecionado.descricao}
          isFooter={false}
          visibility={modalEdicao ? 'block' : 'none'}
          page="SACOLA_MENU_EDICAO"
          param={{
            item: itemSelecionado,
            onEdit: handleEditar,
            onDelete: handleExcluir,
          }}
          btnOnClickClose={() => setModalEdicao(false)}
          customPosition="modal-position-bottom"
        />
      )}

      {modalDetalhes && (
        <Modal
          title={itemSelecionado.descricao}
          isFooter={false}
          visibility={modalDetalhes ? 'block' : 'none'}
          param={{
            item: itemSelecionado,
            montagem: GetMontagem(dadosApp, itemSelecionado.codigo, itemSelecionado.id, itemSelecionado),
          }}
          page="DETALHES"
          btnOnClickClose={() => setModalDetalhes(false)}
        />
      )}

      {obj.itens.length > 0 && width < 992 && <SacolaRodape param={param} />}
    </>
  );
};

Sacola.propTypes = {
  param: P.object,
};
